"use client";
import { Heading, Text, VStack } from "@chakra-ui/react";

export interface ImageType {
  url: string;
  width: number;
  height: number;
}

export interface DescriptionType {
  post: any;
}
export interface AdvertisingAndPartnershipsHeroProps {
  post: any;
}

export const AdvertisingAndPartnershipsHero = ({
  post,
}: AdvertisingAndPartnershipsHeroProps) => {
  return (
    <VStack
      pt="14"
      px="5"
      textAlign="center"
      pb={{
        base: 10,
        md: 14,
      }}
    >
      <Heading
        as="h1"
        size="3xl"
        fontWeight="extrabold"
        letterSpacing="tight"
        lineHeight="1"
      >
        {post.title}
      </Heading>
      <Text
        mt="4"
        fontSize={{
          base: "md",
          lg: "lg",
        }}
      >
        {post.excerpt}
      </Text>
    </VStack>
  );
};

export default AdvertisingAndPartnershipsHero;
